import React from "react";

import Plus_Icon from "@common/images/plus.svg";
import PlusBlack_Icon from "@common/images/plus_black.svg";
import Question_Icon from "@common/images/question.svg";
import Arrow_Icon from "@common/images/arrow_right.svg";
import Pencil_Icon from "@common/images/pencil.svg";
import Eye_Icon from "@common/images/eye.svg";
import Play_Icon from "@common/images/play.svg";
import Magnify_Plus_Icon from "@common/images/magnifier_plus.svg";
import Magnify_Minus_Icon from "@common/images/magnifier_minus.svg";
import Info_Icon from "@common/images/info_icon.svg";
import Hand_Icon from "@common/images/hand.svg";
import LockUrl from "@common/images/locked.svg";
import Camera_Icon from "@common/images/Camera.svg";
import DropDown_Icon from "@common/images/dropdown_arrow.svg";
import Animation_Play_Icon from "@common/images/animation_play.svg";
import Animation_Pause_Icon from "@common/images/animation_pause.svg";

import className from "../../style.module.scss";

// Icon mapping for visual overrides
export const iconMap = {
  Next: <img alt="" src={Arrow_Icon} />,
  Back: <img style={{ transform: "rotate(180deg)" }} alt="" src={Arrow_Icon} />,
  Down: <img style={{ transform: "rotate(90deg)" }} alt="" src={Arrow_Icon} />,
  Up: <img style={{ transform: "rotate(-90deg)" }} alt="" src={Arrow_Icon} />,
  Pencil: <img alt="" src={Pencil_Icon} />,
  Eye: <img alt="" src={Eye_Icon} />,
  Play: <img alt="" src={Play_Icon} />,
  "Magnifier plus": <img alt="" src={Magnify_Plus_Icon} />,
  "Magnifier minus": <img alt="" src={Magnify_Minus_Icon} />,
  Info: <img alt="" src={Info_Icon} />,
  Hand: <img alt="" src={Hand_Icon} />,
  Camera: <img alt="" src={Camera_Icon} />,
  Orange: <img alt="" src={PlusBlack_Icon} />,
  "Animation-Play": <img alt="" src={Animation_Play_Icon} />,
  "Animation-Pause": <img alt="" src={Animation_Pause_Icon} />,
};

// Specialized icons for different hotspot types
const QUESTION_TYPES = ["CSCQ", "MSCQ", "TABLE_QUESTION"];

export const getHotspotIcon = (data, locked, triggered, postTrigger) => {
  const { visualOverride, props } = data;

  // Priority order: Lock > Animation Control > Triggered > Type-specific > Visual override > Default

  // 1. Lock icon for locked hotspots
  if (locked && !triggered) {
    return <img alt="" src={LockUrl} className={className.lockIcon} />;
  }

  // 2. Animation control icons (pause/play)
  if (props.type === "animation-control") {
    // Use visualOverride to determine which icon to show
    if (visualOverride === "Animation-Play") {
      return iconMap["Animation-Play"];
    }
    if (visualOverride === "Animation-Pause") {
      return iconMap["Animation-Pause"];
    }
    // Default to pause icon
    return iconMap["Animation-Pause"];
  }

  // 3. Checkmark for triggered hotspots
  if (triggered && postTrigger !== "no-change") {
    return (
      <svg
        className={className.checkmark}
        xmlns="http://www.w3.org/2000/svg"
        fill="rgb(0,62,107)"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
      </svg>
    );
  }

  // 4. Type-specific icons
  if (QUESTION_TYPES.includes(props.type)) {
    return <img alt="" src={Question_Icon} />;
  }

  if (props.type === "state-changer" && props.stateChangerType === "Dropdown") {
    return <img alt="" src={DropDown_Icon} />;
  }

  // 5. Visual override icons
  if (visualOverride && iconMap[visualOverride]) {
    return iconMap[visualOverride];
  }

  // 6. Default plus icon
  return <img alt="" className={className.hotspotImage} src={Plus_Icon} />;
};

export const hotspotImageBySrc = (src) => {
  const imageUrl = src.includes(window.location.origin)
    ? src
    : `${window.location.origin}${window.location.pathname}${src}`;
  return <img alt="" src={imageUrl} />;
};
